/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AlertAction from './AlertAction/index'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/DesignSystem/TysiaInputQuestion/ListInput/ToggleInput/Option",
  disabled,
  size,
  maxWidth,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  showAlert
  
}) {
let listSelectedValueData = fromData.useDataValue({ viewPath,
context: 'list',
path: 'selected',
})
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let aggregateData = fromAggregate.includes(listSelectedValueData, optionTextValueData)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  disabled,
  size,
  maxWidth,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  showAlert
  
})
let optionTextValueData1 = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
  return (<React.Fragment
>
<div
  data-testid="Option.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 data="list.selected"
 data="option.text"
 aggregate="/Data/aggregate.js includes"
 value={aggregateData}
 onChange={onChange}
 justifyContent="flex-start"
 disabled={disabled}
 size={size}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 data="option.text"
 text={optionTextValueData1}
/>
</React.Fragment>
)}
</TysiaToggle>
<fromFlow.When is={showAlert}>
<AlertAction
  viewPath={`${viewPath}/AlertAction`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}